










import Vue, { VueConstructor } from 'vue'
import { computed, defineComponent } from '@vue/composition-api'
import { useGetters } from '@u3u/vue-hooks'

import Subpage from '@/views/pages/Subpage.vue'
import Expertise from '@/views/pages/Expertise.vue'
import About from '@/views/pages/About.vue'
import Solutions from '@/views/pages/Solutions.vue'
import Products from '@/views/pages/Products.vue'
import Contact from '@/views/pages/Contact.vue'
import FAQ from '@/views/pages/FAQ.vue'
import Jobs from '@/views/pages/JobsListing.vue'
import Apply from '@/views/pages/Apply.vue'
import SecurityReport from '@/views/pages/SecurityReport.vue'

export interface Pages {
  [key: string]: VueConstructor<Vue>
}

// prettier-ignore
/* eslint-disable quote-props */
const pages: Pages = {
  page: Subpage,
  expertise: Expertise,
  about: About,
  jobs: Jobs,
  solutions: Solutions,
  products: Products,
  contact: Contact,
  faq: FAQ,
  apply: Apply,
  'security-report': SecurityReport
}

export default defineComponent({
  name: 'page',
  setup() {
    const { template } = useGetters(['template'])

    const component = computed<VueConstructor<Vue>>(
      () => pages[template.value] || Subpage
    )

    return {
      component,
    }
  },
})
